export const validateGroupName = (name: string) => {
  switch (name) {
    case 'periodoIds':
      return 'periodo'
    case 'periodoSelectIds':
      return 'periodo'

    case 'empresaIds':
      return 'empresa'
    case 'empresaSelectIds':
      return 'empresa'
    case 'tipoCentroIds':
      return 'tipoCentro'
    case 'tipoCentroSelectIds':
      return 'tipoCentro'

    case 'centroCdLojaIds':
      return 'loja'
    case 'centroCdLojaSelectIds':
      return 'loja'

    case 'mundoIds':
      return 'mundo'
    case 'mundoSelectIds':
      return 'mundo'

    case 'fornecedorIds':
      return 'fornecedor'
    case 'fornecedorSelectIds':
      return 'fornecedor'

    case 'gerenteProdutoIds':
      return 'gerenteProduto'
    case 'gerenteProdutoSelectIds':
      return 'gerenteProduto'

    case 'categoriaCompactaIds':
      return 'categoriaCompacta'
    case 'categoriaCompactaSelectIds':
      return 'categoriaCompacta'

    case 'categoriaIds':
      return 'categoria'
    case 'categoriaSelectIds':
      return 'categoria'

    case 'gerenteCategoriaIds':
      return 'gerenteCategoria'
    case 'gerenteCategoriaSelectIds':
      return 'gerenteCategoria'

    case 'statusIds':
      return 'statusEstoque'
    case 'statusSelectIds':
      return 'statusEstoque'

    case 'curvaAbcIds':
      return 'curvaABC'
    case 'curvaAbcSelectIds':
      return 'curvaABC'
    case 'subCategoriaIds':
      return 'subCategoria'
    case 'subCategoriaSelectIds':
      return 'subCategoria'
    default:
      return null
  }
}
